import React from "react";
import { Box, Typography, Button, Container, Paper } from "@mui/material";
import { useAuth } from "../../firebase";
import { setLocalStorage } from "../../utils/storage";

const PendingApprovalPage: React.FC = () => {
  const { signOut } = useAuth();

  const [password, setPassword] = React.useState("");

  const handlePasswordSubmit = () => {
    if (password === "family") {
      setLocalStorage("allow_access", "true");
      window.location.reload();
    } else {
      alert("Incorrect password");
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "background.default",
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            p: 4,
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            gap: 3,
            borderRadius: 2,
          }}
        >
          <Box
            component="img"
            src="/logo.svg"
            alt="Family Tree & Me"
            sx={{
              height: 80,
              width: "auto",
              mx: "auto",
              mb: 2,
            }}
          />

          <Typography variant="h4" component="h1" gutterBottom color="primary">
            Welcome to Family Tree & Me
          </Typography>

          <Typography variant="h6" color="text.secondary" gutterBottom>
            Your account is pending approval
          </Typography>

          <Typography variant="body1" color="text.primary">
            We are currently in an invite-only early access phase. Your account has
            been created successfully, but requires administrator approval before
            you can access the store.
          </Typography>

          <Typography variant="body2" color="text.secondary">
            Please contact the administrator or the family member who invited you
            to approve your email address.
          </Typography>

           <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'center' }}>
            <Typography variant="caption" color="text.secondary">
              Have an access code?
            </Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter password"
                    style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                />
                <Button variant="contained" onClick={handlePasswordSubmit}>
                    Enter
                </Button>
            </Box>
          </Box>


          <Box sx={{ mt: 2 }}>
            <Button variant="outlined" color="primary" onClick={signOut}>
              Sign Out
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default PendingApprovalPage;
